import Rest from '../Rest'

export default class AddressTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/address_types'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
